class ErrorBus {
    listeners = new Set();

    emit(error) {
        this.listeners.forEach((cb) => cb(error));
    }

    subscribe(cb) {
        this.listeners.add(cb);
        return () => this.listeners.delete(cb);
    }
}
  
export const errorBus = new ErrorBus();
  